var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3333,
    cy: 12.8207,
    r: 12.3846,
    fill: "#071E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.38184,
    y: 4.86938,
    width: 17.0822,
    height: 17.0822,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2113 19.1045V13.3036L11.3607 15.1542L10.3643 14.1221L13.9231 10.5633L17.4819 14.1221L16.4854 15.1542L14.6348 13.3036V19.1045H13.2113ZM8.229 11.2751V9.13983C8.229 8.74836 8.36839 8.41324 8.64716 8.13447C8.92594 7.85569 9.26106 7.71631 9.65252 7.71631H18.1936C18.5851 7.71631 18.9202 7.85569 19.199 8.13447C19.4778 8.41324 19.6172 8.74836 19.6172 9.13983V11.2751H18.1936V9.13983H9.65252V11.2751H8.229Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseFileIcon);
export default __webpack_public_path__ + "static/media/chooseFileIcon.d9d025ddddf036b907bd57ddf136ea25.svg";
export { ForwardRef as ReactComponent };